import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import { isMobile, localStoragePackage } from '@libs/util'

Vue.use(Router)

const router = new Router({ routes })

router.beforeEach(async (to, from, next) => {
  if (['search', 'reservation', 'online', 'record', 'information'].includes(to.name)) {
    const ticket = localStoragePackage('get', 'ticket')
    if (!ticket) {
      window.location.href = window.config.attestationUrl
      return
    }
  }
  next()
})

router.afterEach(to => {
  document.title = window.config.headerTitle
  window.scrollTo(0, 0)
})

export default router
